const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProducto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    width: 24,
    viewBox: "0 0 6.35 6.35",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m 2.1173362,0.52916854 c -0.070428,1.335e-5 -0.1379451,0.0280994 -0.187604,0.07804 L 0.68524321,1.8516965 H 4.1251602 l 1.322529,-1.32252796 z m 3.703492,0.375207 -1.322528,1.32252896 v 3.439917 L 5.7448571,4.4202644 c 0.049182,-0.049997 0.076506,-0.1174731 0.07597,-0.1876039 z M 0.52916521,2.3809155 v 3.176341 c 5.8129e-4,0.1453274 0.11824862,0.2629943 0.263576,0.263575 1.05878029,0 2.11756069,0 3.17634099,0 v -3.439916 z",
    style: {
      color: "#000000",
      fontStyle: "normal",
      fontVariant: "normal"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducto);
export default __webpack_public_path__ + "static/media/producto.3e12308f2cbb817c59058df7680a8533.svg";
export { ForwardRef as ReactComponent };